import { AlertTriangle, Clock } from 'lucide-react';
import { useEffect, useState } from 'react';

interface PreviewCountdownProps {
  expiresAt: string;
  onExpire: () => void;
}

export function PreviewCountdown({ expiresAt, onExpire }: PreviewCountdownProps) {
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    const calc = () => Math.max(0, Math.floor((new Date(expiresAt).getTime() - Date.now()) / 1000));
    setRemaining(calc());

    const interval = setInterval(() => {
      const secs = calc();
      setRemaining(secs);
      if (secs === 0) {
        clearInterval(interval);
        onExpire();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [expiresAt, onExpire]);

  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;
  const isLow = remaining < 120;

  if (remaining === 0) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-red-50 text-red-600 text-sm font-medium">
        <AlertTriangle className="w-4 h-4" />
        Preview expirado — sube el archivo de nuevo
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium ${
      isLow
        ? 'bg-amber-50 text-amber-700'
        : 'bg-slate-100 text-slate-600'
    }`}>
      <Clock className="w-4 h-4" />
      Preview expira en {minutes}:{String(seconds).padStart(2, '0')}
    </div>
  );
}
